import React, { useEffect, useState } from "react";
import styles from "../HomePage/HomePage.module.css";
import NavBar from "../../components/NavBar/NavBar";
import { Link, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../App";

export default function SavedListingsPage() {
    const [isLoading, setIsLoading] = useState(true);
    const [selectedListing, setSelectedListing] = useState(null);
    const [globalLists, setGlobalLists] = useState([]);
    const [displayLists, setDisplayLists] = useState([]);
    const navigate = useNavigate();

    // Fetch homepage listings
      useEffect(() => {
        let cancelled = false;
    
        async function fetchListings() {
          setIsLoading(true);
          try {
            const response = await fetch(`${BASE_URL}backend/get_saved_listings.php`);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
    
            const data = await response.json();
    
            // ---- FLEXIBLE SHAPE HANDLING ----
            const rawListings = Array.isArray(data)
              ? data
              : Array.isArray(data.listings)
              ? data.listings
              : Array.isArray(data.data)
              ? data.data
              : [];
    
            const fetched = rawListings.map((item) => {
              // image_paths can be array OR comma-separated string OR null
                let imageArray;

                if (Array.isArray(item.image_paths)) {
                    imageArray = item.image_paths;
                } else if (typeof item.image_paths === "string" && item.image_paths.length > 0) {
                    imageArray = item.image_paths
                        .split(",")            // split into array
                        .map(s => s.trim())    // clean whitespace
                        .filter(s => s.length > 0); // remove empty
                } else {
                    imageArray = [];
                }
    
              const firstImage =
                imageArray[0] || item.img || item.image || "";
    
              const imgSrc =
                !firstImage
                  ? ""
                  : firstImage.startsWith("http") || firstImage.startsWith("/")
                  ? firstImage
                  : `${BASE_URL}${firstImage}`;
    
              return {
                id: item.post_id,
                // FIX: Handle multiple possible field names for author ID
                authorId: item.user_id || item.creator || item.owner_id || null,
                img: imgSrc,
                title: item.title || "",
                price: Number(
                  item.rent !== undefined ? item.rent : item.price || 0
                ),
                bedrooms: parseInt(
                  item.bed !== undefined ? item.bed : item.bedrooms || 0
                ),
                bathrooms: parseInt(
                  item.bath !== undefined ? item.bath : item.bathrooms || 0
                ),
                address: item.addr || item.address || "",
                sqft: Number(
                  item.sqFT !== undefined ? item.sqFT : item.sqft || 0
                ),
                utils: Array.isArray(item.utils)
                  ? item.utils.map((u) => String(u).toLowerCase())
                  : String(item.utils || "")
                      .split(",")
                      .map((u) => u.trim().toLowerCase())
                      .filter((u) => u.length > 0),
                tags: Array.isArray(item.tags)
                  ? item.tags.map((t) => String(t).toLowerCase())
                  : String(item.tags || "")
                      .split(",")
                      .map((t) => t.trim().toLowerCase())
                      .filter((t) => t.length > 0),
                pageLink: item.post_id,
              };
            });
    
            if (!cancelled) {
              setGlobalLists(fetched);
              setDisplayLists(fetched);
            }
          } catch (err) {
            console.error("HomePage fetch error:", err);
            if (!cancelled) {
              setGlobalLists([]);
              setDisplayLists([]);
            }
          } finally {
            if (!cancelled) setIsLoading(false);
          }
        }
    
        fetchListings();
        return () => {
          cancelled = true;
        };
      }, []);

      // ---------------- CARD CLICK (whole white box) ----------------
      const handleCardClick = async (listing) => {
          try {
            await fetch(`${BASE_URL}backend/track_event.php`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                event_type: "listing_click",
                post_id: listing.pageLink,
              }),
            });
            console.log(`Tracked click for listing ${listing.pageLink}`);
          } catch (err) {
            console.error("Track error:", err);
          } finally {
            navigate(`/houseListing/${listing.pageLink}`);
          }
        };

    return (
        <div className={styles.page}>
            <NavBar />
            <h1 style={{textAlign: "center", margin: "24px 0",}}>Saved Listings</h1>
            {/* LISTINGS */}
      {isLoading ? (
        <div className="container">Loading…</div>
      ) : displayLists.length === 0 ? (
        <div className="container">No listings found.</div>
      ) : (
        <section className={styles.grid}>
          {displayLists.map((l, i) => (
            <article key={i} className={styles.card} onClick={() => handleCardClick(l)}>
              {/* TITLE AT TOP */}
              <div className={styles.cardTitleTop}>
                {l.title || `${l.bedrooms} bed, ${l.bathrooms} bath apartment`}
              </div>

              {/* IMAGE */}
              <div className={styles.imageWrap}>
                <img src={l.img} alt="Listing" />
              </div>

              {/* BOTTOM META - Price, beds/baths, address */}
              <div className={styles.meta}>
                <div className={styles.price}>${l.price}/month</div>

                <div className={styles.bedsBaths}>
                  {l.bedrooms} bed, {l.bathrooms} bath apartment
                </div>

                <div className={styles.subtitleRow}>
                  <div className={styles.subtitle}>{l.address}</div>
                </div>
              </div>
            </article>
          ))}
        </section>
      )}
        </div>
    )
}